import Vue from 'vue'

import { LayoutPlugin, SpinnerPlugin, FormSelectPlugin, FormRadioPlugin, FormGroupPlugin, ModalPlugin } from 'bootstrap-vue'

Vue.use(LayoutPlugin)
Vue.use(SpinnerPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormRadioPlugin)
Vue.use(FormGroupPlugin)
Vue.use(ModalPlugin)